import { CustomerDataState } from './customerData.types';

import { RootState } from '~/redux/store';

export const selectSelectedCustomerData = ({
  customerData,
}: RootState): CustomerDataState['selectedCustomerData'] =>
  customerData.selectedCustomerData;

export const selectSaveAction = ({
  customerData,
}: RootState): CustomerDataState['saveAction'] => customerData.saveAction;
